import { render } from "./TopPostByMode.vue?vue&type=template&id=ad059efc&scoped=true"
import script from "./TopPostByMode.vue?vue&type=script&lang=js"
export * from "./TopPostByMode.vue?vue&type=script&lang=js"

import "./TopPostByMode.vue?vue&type=style&index=0&id=ad059efc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad059efc"]])

export default __exports__